import type { Channel, Zone } from '../types';

export interface ZoneChannelGroup {
  id: string;
  name: string;
  channels: Channel[];
}

export interface ChannelRailSections {
  unzonedChannels: Channel[];
  zoneGroups: ZoneChannelGroup[];
}

export const zoneCollapseStorageKey = (
  accountId: string,
  guildId: string,
  zoneId: string,
): string =>
  `borgee:zone-collapse:${JSON.stringify([accountId, guildId, { kind: 'zone', id: zoneId }])}`;

export const groupChannelsByZone = (channels: Channel[], zones: Zone[]): ChannelRailSections => {
  const unzonedChannels: Channel[] = [];
  const named = new Map(
    zones.map((zone) => [
      zone.id,
      {
        id: zone.id,
        name: zone.name,
        channels: [] as Channel[],
      },
    ]),
  );
  for (const channel of channels) {
    if (channel.parent_id === null) {
      unzonedChannels.push(channel);
      continue;
    }
    const group = named.get(channel.parent_id);
    if (!group) throw new Error(`Channel ${channel.id} has no Zone in the channel snapshot`);
    group.channels.push(channel);
  }
  const groups = [...named.values()].sort(
    (left, right) =>
      left.name.localeCompare(right.name, undefined, { sensitivity: 'base', numeric: true }) ||
      left.id.localeCompare(right.id),
  );
  return { unzonedChannels, zoneGroups: groups };
};

export const zoneUnreadCount = (channels: Channel[]): number =>
  channels.reduce(
    (count, channel) =>
      channel.is_member !== false && channel.archived_at == null
        ? count + (channel.unread_count ?? 0)
        : count,
    0,
  );
